// Shared constants + helpers for the Wazuh security module family
// (Vulnerability Mgmt, SCA/Compliance, Integrity Monitor, Asset Inventory, Detection Config).
// Reuses the MITRE severity convention (orange = high) so all security pages look consistent.

// ── CVSS / vulnerability severity ────────────────────────────────────────────────
// Wazuh reports severity as: critical | high | medium | low | none
export const VULN_SEVERITY_HEX = {
    critical: '#ef4444',
    high: '#f97316',
    medium: '#f59e0b',
    low: '#3b82f6',
    none: '#64748b',
};

export const VULN_SEVERITY_BADGE = {
    critical: 'red',
    high: 'high',
    medium: 'amber',
    low: 'blue',
    none: 'gray',
};

// Wazuh vulnerability status values (per CVE per package)
export const VULN_STATUS_BADGE = {
    outdated: 'red',
    fixed: 'green',
    ignored: 'gray',
};

// ── SCA / compliance score color (0-100) ─────────────────────────────────────────
export function scoreColor(score) {
    const s = Number(score) || 0;
    if (s >= 90) return '#10b981';   // emerald — compliant
    if (s >= 75) return '#3b82f6';   // blue   — mostly compliant
    if (s >= 50) return '#f59e0b';   // amber  — partial
    if (s >= 25) return '#f97316';   // orange — poor
    return '#ef4444';                // red    — critical
}

export function scoreBadge(score) {
    const s = Number(score) || 0;
    if (s >= 90) return 'green';
    if (s >= 75) return 'blue';
    if (s >= 50) return 'amber';
    if (s >= 25) return 'high';
    return 'red';
}

// SCA check result -> badge (Wazuh: pass | fail | invalid)
export const CHECK_RESULT_BADGE = {
    pass: 'green',
    fail: 'red',
    invalid: 'gray',
};

// ── FIM / integrity event types ──────────────────────────────────────────────────
export const FIM_EVENT_BADGE = {
    added: 'green',
    modified: 'amber',
    deleted: 'red',
};

// ── OS family colors (asset inventory) ───────────────────────────────────────────
export const OS_FAMILY_HEX = {
    linux: '#f5a623',
    windows: '#0078d6',
    macos: '#555555',
    unix: '#111111',
    other: '#64748b',
};

// ── shared helpers (kept local so each module is self-contained) ──────────────────
export function compactNum(n) {
    const v = Number(n) || 0;
    if (v >= 1_000_000) return (v / 1_000_000).toFixed(1) + 'M';
    if (v >= 1_000) return (v / 1_000).toFixed(1) + 'K';
    return String(v);
}

// Wazuh rule level (0-15) -> severity bucket (same mapping as mitreConstants)
export function levelToSeverity(level) {
    const l = Number(level) || 0;
    if (l >= 11) return 'critical';
    if (l >= 8) return 'high';
    if (l >= 4) return 'medium';
    return 'low';
}

export const SEVERITY_BADGE = {
    critical: 'red',
    high: 'high',
    medium: 'amber',
    low: 'blue',
};

export const TIME_OPTIONS = [
    { label: '24h', hours: 24 },
    { label: '7d', hours: 168 },
    { label: '30d', hours: 720 },
];
